


















































import {
    Component, Inject, Mixins, Model, Prop,
} from 'vue-property-decorator';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import { ProductTemplateContent } from '@/assets/interface/Product';
import { Validator } from 'vee-validate';

@Component
export default class OTextField extends Mixins(IsMobileMixin) {
    @Model('change', { type: Object }) public model!: ProductTemplateContent;

    // this is for veevalidate
    @Inject('$validator') public $validator!: Validator;

    @Prop({ default: 'Label' }) public label!: string;

    @Prop({ default: '' }) public validate!: string;

    @Prop({ default: '' }) public placeHolder!: string;

    get field() {
        return `field${this.model.id}`;
    }

    get errorKey() {
        return `errorMessages-${this.model.id}`;
    }
}
